module.exports = __webpack_public_path__ + "static/media/tip1.6193f837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/tips/tip1.jpg
// module id = 972
// module chunks = 0